import * as React from 'react'
import {
  AmountsTable,
  AmountPageProps,
  parseProps,
  drawHeaderRow,
  drawExtendedRow,
  formatNumber,
  drawSummaryRow,
} from '@/modules/drivers/shared/timesheet-amounts'
import { Loader } from '@/ui'

import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

import {
  ForeignAmountsCountryPeriod,
  useForeignAmountsPreviewQuery,
} from '@/lib/api/company/timesheet/foreignAmounts'
import {
  SettingsSectionTab,
  SettingsSectionWithTabs,
} from '@/modules/settings/components/SettingsSectionWithTabs'
import { ForeignAmountSingleCountry } from '../shared/timesheet-amounts/ForeignAmountSingleCountry'

import { TimesheetActionBarSingleContainer } from '../tabs/registry/components/timesheet/TimesheetActionBarSingleContainer'

export const DriverForeignAmountsPreview = (props: AmountPageProps) => {
  const { companyId, driverId, yearMonth } = parseProps(props)
  const { t } = useLocalize()
  const query = useForeignAmountsPreviewQuery({
    companyId,
    driverId,
    yearMonth,
  })
  const rows = (query.data || []) as ForeignAmountsCountryPeriod[]

  return (
    <div className="tw-flex tw-h-full tw-min-h-0 tw-w-full tw-flex-col">
      <TimesheetActionBarSingleContainer companyId={companyId} driverId={driverId} yearMonth={yearMonth} />
      {/* Rodzic ma overflow-hidden, więc treść przewija się tutaj. */}
      <div className="tw-relative tw-flex tw-min-h-0 tw-w-full tw-flex-1 tw-flex-col tw-gap-6 tw-overflow-auto tw-p-4">
        <h1 className="tw-mt-1 tw-text-xl tw-text-base-content">
          {t('menu.foreign-amounts')}
        </h1>

        {query.isFetching && (
          <Loader position="absolute" className="tw-h-full tw-w-full" />
        )}

        {!query.isFetching && query.isSuccess && rows.length === 0 ? (
          <div>
            <p>{t('common.no-data-to-display')}</p>
          </div>
        ) : null}

        {rows.length ? (
          <SettingsSectionWithTabs classNameNavigation="tw-w-[200px] tw-flex-none">
            {rows.map((r, i) => {
              return (
                <SettingsSectionTab
                  name={r.country.code}
                  title={r.country.name}
                  key={i}
                >
                  <ForeignAmountSingleCountry data={r} />
                </SettingsSectionTab>
              )
            })}
          </SettingsSectionWithTabs>
        ) : null}
      </div>
    </div>
  )
}
